<template>
  <form v-on:submit.prevent="submit()" class="new-menu-log-in-form">
    <h5>{{ textLogIn }}</h5>
    <template v-if="!reset">
      <global-errors v-bind:value="loginErrors"/>
      <input-text v-model="loginForm.username" v-bind:placeholder="textUsernameLabel"/>
      <input-secret v-model="loginForm.password" v-bind:placeholder="textPasswordLabel"/>
      <button type="submit" class="btn btn-primary">
        {{ textLogInSubmit }}
        <i v-if="submitting || redirecting" class="fal fa-loading-white-12"></i>
      </button>
      <a href="#" v-on:click.prevent="loginForm.remember=!loginForm.remember">
        <i v-bind:class="{'fal fa-check-square': loginForm.remember, 'far fa-square': !loginForm.remember}"></i>
        {{ textRememberLabel }}
      </a>
      <a href="#" v-on:click.prevent="reset = true" class="right">{{ textLostLink }}</a>
    </template>
    <template v-else="">
      <h6>{{ textLostTitle }}</h6>
      <p>{{ textLostInfo }}</p>
      <template v-if="!resetSuccess">
        <global-errors v-bind:value="resetErrors.email"/>
        <input-text v-model="resetForm.email" v-bind:placeholder="textEmailLabel"/>
        <button type="submit" class="btn btn-primary">
          {{ textLostSubmit }}
          <i v-if="submitting" class="fal fa-loading-white-12"></i>
        </button>
      </template>
      <template v-else="">
        <p class="alert alert-success">{{ textLostSuccess }}</p>
      </template>
      <a href="#" v-on:click.prevent="reset = false" class="right">{{ textBackToLogIn }}</a>
    </template>
  </form>
</template>

<script>
import Axios from "axios"
export default {
  name: "menu-log-in",
  props: ["textLogIn", "textLogInSubmit", "textUsernameLabel", "textPasswordLabel", "textRememberLabel", "textEmailLabel", "textLostLink", "textLostTitle", "textLostInfo", "textLostSubmit", "textLostSuccess", "textLostFailure", "textBackToLogIn"],
  data: function () {
    return {
      reset: false,
      resetSuccess: false,
      loginForm: {
        username: "",
        password: "",
        remember: true
      },
      loginErrors: [],
      resetForm: {
        email: ""
      },
      resetErrors: {},
      submitting: false,
      redirecting: false
    };
  },
  methods: {
    submit: function () {
      if (!this.reset) {
        this.submitLogin();
      } else {
        this.submitReset();
      }
    },
    submitLogin: function () {
      var instance = this;
      instance.submitting = true;
      instance.loginErrors = [];
      window.logIn(
          instance.loginForm.username,
          instance.loginForm.password,
          instance.loginForm.remember,
          function () {
            instance.submitting = false;
            instance.redirecting = true;
          },
          function (messages) {
            instance.submitting = false;
            if (messages) {
              for (var i = 0; i < messages.length; i++) {
                instance.loginErrors.push(messages[i].message);
              }
            }
          });
    },
    submitReset: function () {
      var instance = this;
      instance.$clearFormErrors(instance.resetErrors);
      instance.submitting = true;
      var formData = new URLSearchParams();
      formData.append("email", instance.resetForm.email);
      Axios(
          {
            url: window.contextPath + "/rest/reset-login-request",
            method: "POST",
            data: formData
          })
          .then(function (response) {
            if (response.data.status === "ok") {
              instance.resetSuccess = true;
            } else {
              instance.$showFormErrors(instance.resetErrors, response.data.errors);
            }
          })
          .catch(function () {
            instance.$showFormErrors(instance.resetErrors, {
              email: instance.textLostFailure
            });
          })
          .then(function () {
            instance.submitting = false;
          });
    }
  }
}
</script>
